<div class="close-icon">
    <mat-icon class="mat-icon notranslate material-icons mat-icon-no-color" style="cursor: pointer;" (click)="cancel()">close</mat-icon>
</div>
<div class="pagination"> {{activeIndex}} / {{project.images.length}}</div>
<swiper (activeIndexChange)="onActiveIndexChange($event)" class="swiper-container" [navigation]="true" [pagination]="{type: 'bullets', clickable: true}" [navigation]="true" [slideActiveClass]="'active-bullet'">
    <ng-template swiperSlide *ngFor="let image of project.images">
        <div class="swiper-item">
            <img [src]="SERVER_URL + 'images/' + project.projectCode + '/images/' + image.fileName">
        </div>
    </ng-template>
</swiper>